/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
import React from 'react';
import PropTypes from 'prop-types';
import CybsButtonGroup from '@cybs-ui/components/lib/button-group';
import CollapsibleButton from './collapsible-button';
import RightActions from './right-actions';

const RightActionBar = ({
  actionBarId,
  collapsible,
  dataTest,
  i18n: i18nProp,
  isActionBarActive,
  numberOfActionsToShow,
  onChange,
  rightActions
}) => {
  const i18n = {
    ...RightActionBar.defaultProps.i18n,
    ...i18nProp
  };
  return (
    <CybsButtonGroup dataTest={dataTest}>
      <RightActions
        dataTest={dataTest}
        actionBarId={actionBarId}
        onChange={onChange}
        rightActions={rightActions}
        isActionBarActive={isActionBarActive}
        i18n={i18n}
        numberOfActionsToShow={numberOfActionsToShow}
      />
      {collapsible && collapsible.location !== 'left' ? (
        <CollapsibleButton
          actionBarId={actionBarId}
          collapsible={collapsible}
          dataTest={dataTest}
          i18n={i18n}
        />
      ) : null}
    </CybsButtonGroup>
  );
};

RightActionBar.displayName = 'RightSide';

RightActionBar.propTypes = {
  /**
   * Generated unique id
   */
  actionBarId: PropTypes.string.isRequired,
  /**
   * Actions on the right side of the bar. May pass array of button configs
   * or a React element.
   */
  rightActions: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(
      PropTypes.shape({
        ariaLabel: PropTypes.string,
        colorScheme: PropTypes.string,
        disabled: PropTypes.func,
        iconClass: PropTypes.string,
        iconLocation: PropTypes.string,
        href: PropTypes.string,
        label: PropTypes.string,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func,
        tag: PropTypes.string,
        variant: PropTypes.string
      })
    )
  ]),
  /**
   * Number of buttons to show before overflowing into menu.
   * */
  numberOfActionsToShow: PropTypes.number,
  /**
   * Action Bar for Grid proptypes
   */
  isActionBarActive: PropTypes.bool,
  /**
   * On Change is used for advanced dropdown menu for overflow Actions
   * */

  onChange: PropTypes.func,
  /**
   * Required data testing string
   */

  dataTest: PropTypes.string,
  /**
   * collapsible configuration
   */

  collapsible: PropTypes.shape({
    isOpen: PropTypes.bool,
    onClick: PropTypes.func,
    location: PropTypes.oneOf(['left', 'right'])
  }),
  /**
   * Strings for the component.
   */
  i18n: PropTypes.shape({
    collapsibleButtonLabel: PropTypes.string,
    collapsedLabel: PropTypes.string,
    expandedLabel: PropTypes.string,
    title: PropTypes.string.isRequired
  })
};

RightActionBar.defaultProps = {
  i18n: {
    collapsibleButtonLabel: 'Accordion toggle',
    collapsedLabel: 'Collapsed',
    expandedLabel: 'Expanded'
  },
  rightActions: [],
  numberOfActionsToShow: Infinity,
  isActionBarActive: true,
  onChange: () => {},
  dataTest: '',
  collapsible: undefined
};
export default RightActionBar;
